import React from "react";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import { useStyles } from "./styles";

export default function Step3BusinessHours({ businessHours, updateHours, DAYS }) {
  const c = useStyles();
  return (
    <>
      <Typography variant="h6" gutterBottom>Horarios por día</Typography>
      {businessHours.map((h, i) => (
        <div key={i} className={c.dayRow}>
          <FormControlLabel
            control={<Checkbox checked={!!h.isOpen} onChange={(e) => updateHours(i, "isOpen", e.target.checked)} />}
            label={DAYS[i]}
          />
          <TextField type="time" size="small" label="Apertura" value={h.openTime || "09:00"} onChange={(e) => updateHours(i, "openTime", e.target.value)} InputLabelProps={{ shrink: true }} />
          <TextField type="time" size="small" label="Cierre" value={h.closeTime || "18:00"} onChange={(e) => updateHours(i, "closeTime", e.target.value)} InputLabelProps={{ shrink: true }} />
          <TextField type="number" size="small" label="Slot (min)" value={h.slotDuration || 60} onChange={(e) => updateHours(i, "slotDuration", +e.target.value || 60)} style={{ width: 80 }} />
        </div>
      ))}
    </>
  );
}
